import { Strings } from "@app/constants";

export const addressFields = [
  { name: "firstName", label: Strings.common.firstName },
  { name: "lastName", label: Strings.common.lastName },
  { name: "phoneNumber", label: Strings.common.phoneNumber },
  { name: "email", label: Strings.common.emailAddress },
  { name: "address", label: Strings.common.address },
  { name: "city", label: Strings.common.townAndCity },
  { name: "state", label: Strings.common.state },
  { name: "country", label: Strings.fields.country },
  { name: "zipCode", label: Strings.common.zipcode },
  { name: "drivingLicenseNumber", label: Strings.common.drivingLicence },
];

export const headersSteps = [
  // { label: Strings.headersSteps.vehicleSelections, icon: "mdi:car" },
  { label: Strings.headersSteps.dateAndTime, icon: "lets-icons:date-fill" },
  {
    label: Strings.headersSteps.yourDetails,
    icon: "material-symbols-light:person",
  },
  { label: Strings.headersSteps.locations, icon: "mdi:map-marker" },
  { label: Strings.headersSteps.confirmations, icon: "ic:round-check-circle" },
];

export const timeSlots = [
  "10:00",
  "11:00",
  "12:00",
  "01:00",
  "02:00",
  "03:00",
  "04:00",
  "05:00",
  "06:00",
];

export const locations = [
  {
    id: 1,
    name: "Downtown Showroom",
    address: "123 Main Street",
    city: "Delhi, India",
    pincode: "1001",
  },
  {
    id: 2,
    name: "Westside Showroom",
    address: "123 Main Street",
    city: "Delhi, India",
    pincode: "1001",
  },
  {
    id: 3,
    name: "Eastside Showroom",
    address: "123 Main Street",
    city: "Delhi, India",
    pincode: "1001",
  },
];
